import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as Lightning } from '../assets/lightning.svg';
import { ReactComponent as Secure } from '../assets/secure.svg';
import { ReactComponent as Tick } from '../assets/tick.svg';

export default function TrustBlocks() {
  const blocks = [
    [<Secure className="h-full" />, <FormattedMessage id="TRUST_BLOCK_1" />],
    [
      <Tick className="h-full transform scale-90" />,
      <FormattedMessage id="TRUST_BLOCK_2" />,
    ],
    [<Lightning className="h-full" />, <FormattedMessage id="TRUST_BLOCK_3" />],
  ];
  return (
    <div
      className="
        md:flex justify-center lg:justify-between
        w-full max-w-lg md:max-w-none px-4 md:px-8 lg:px-0
        text-gray-200 text-left text-sm sm:text-lg md:text-sm lg:text-base sm:leading-tight">
      {blocks.map((block, index) => (
        <div
          className="flex items-center md:w-1/3 lg:w-auto mx-6 mt-6 md:mt-0 md:mx-2 rounded-lg"
          key={index}>
          <div
            className="
              flex justify-center md:justify-end flex-shrink-0
              w-12 h-12 sm:w-16 sm:h-16 md:h-12 md:w-12
              text-gray-800 opacity-50">
            {block[0]}
          </div>
          <div className="lg:w-56 pl-8 md:pl-4 lg:pr-4">{block[1]}</div>
        </div>
      ))}
    </div>
  );
}
